var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3172 7.44193L9.69219 13.0669C9.57491 13.1842 9.41585 13.2501 9.25 13.2501C9.08415 13.2501 8.92509 13.1842 8.80781 13.0669C8.69054 12.9496 8.62465 12.7906 8.62465 12.6247C8.62465 12.4589 8.69054 12.2998 8.80781 12.1826L13.3664 7.62474H1.125C0.95924 7.62474 0.800269 7.55889 0.683058 7.44168C0.565848 7.32447 0.5 7.1655 0.5 6.99974C0.5 6.83398 0.565848 6.67501 0.683058 6.5578C0.800269 6.44059 0.95924 6.37474 1.125 6.37474H13.3664L8.80781 1.81692C8.69054 1.69965 8.62465 1.54059 8.62465 1.37474C8.62465 1.20888 8.69054 1.04983 8.80781 0.93255C8.92509 0.815274 9.08415 0.74939 9.25 0.74939C9.41585 0.74939 9.57491 0.815274 9.69219 0.93255L15.3172 6.55755C15.3753 6.61559 15.4214 6.68453 15.4529 6.7604C15.4843 6.83627 15.5005 6.9176 15.5005 6.99974C15.5005 7.08187 15.4843 7.1632 15.4529 7.23907C15.4214 7.31495 15.3753 7.38388 15.3172 7.44193Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftDisableIcon);
export default __webpack_public_path__ + "static/media/leftDisableIcon.66c0f70d6d12ed8c19bab25df16bb671.svg";
export { ForwardRef as ReactComponent };